import { render, staticRenderFns } from "./handoverList.vue?vue&type=template&id=65614305&scoped=true"
import script from "./handoverList.vue?vue&type=script&lang=js"
export * from "./handoverList.vue?vue&type=script&lang=js"
import style0 from "./handoverList.vue?vue&type=style&index=0&id=65614305&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65614305",
  null
  
)

export default component.exports